import React from 'react'
import { NavLink, Outlet, useNavigate } from 'react-router-dom'
import { Users, Users2, BarChart3, LogOut, Rss } from 'lucide-react'
import { useAuth } from '@/contexts/Auth0Context'
import { Button } from '@/components/ui/Button'

const navigationItems = [
  { name: 'Users', href: '/admin/users', icon: Users },
  { name: 'Relationships', href: '/admin/relationships', icon: Users2 },
  { name: 'Reports', href: '/admin/reports', icon: BarChart3 },
  { name: 'Curated Sources', href: '/admin/curated-sources', icon: Rss }
]

const AdminLayout: React.FC = () => {
  const { logout } = useAuth()
  const navigate = useNavigate()

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  return (
    <div className="min-h-screen flex bg-gray-50">
      <aside className="w-64 flex-shrink-0 bg-white border-r border-gray-200 flex flex-col">
        <div className="h-16 flex items-center px-6 border-b border-gray-200">
          <h1 className="text-xl font-bold text-primary-600">SkyMent Admin</h1>
        </div>

        <nav className="flex-1 px-3 py-4 space-y-1">
          {navigationItems.map((item) => {
            const Icon = item.icon
            return (
              <NavLink
                key={item.name}
                to={item.href}
                className={({ isActive }) =>
                  `flex items-center px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-primary-50 text-primary-600'
                      : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                  }`
                }
              >
                <Icon className="w-4 h-4 mr-3" />
                {item.name}
              </NavLink>
            )
          })}
        </nav>

        <div className="p-3 border-t border-gray-200">
          <Button variant="ghost" size="sm" onClick={handleLogout} className="w-full justify-start text-gray-500 hover:text-gray-700">
            <LogOut className="w-4 h-4 mr-2" />
            Logout
          </Button>
        </div>
      </aside>

      <main className="flex-1 p-8">
        <Outlet />
      </main>
    </div>
  )
}

export default AdminLayout
